import { createContext, useContext, useState, useCallback } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  // Function to add a new toast
  const showToast = useCallback(({message, bg = 'primary', autohide = true, delay = 5000, title = 'Notification'}) => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, bg, autohide, delay, title }]);
  }, []);

  // Function to remove a toast
  const removeToast = (id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  };

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      {/* Global container for stacking toasts */}
      <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999, position: 'fixed', top: 0, right: 0 }}>
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            onClose={() => removeToast(toast.id)}
            bg={toast.bg}
            delay={toast.autohide !== false ? toast.delay || 5000 : null}
            autohide={toast.autohide !== false}
          >
            <Toast.Header>
              <strong className="me-auto">{toast.title}</strong>
            </Toast.Header>
            <Toast.Body className={toast.bg === 'dark' || toast.bg === 'danger' || toast.bg === 'primary' || toast.bg === 'success' ? 'text-white' : ''}>
              {toast.message}
            </Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
